/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Jump_Bullet_2Inputs */

const en_features_jump_bullet_2 = /** @type {(inputs: Features_Jump_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Want to only listen to the abstract? Or skip to the results first? You can do that!`)
};

const es_features_jump_bullet_2 = /** @type {(inputs: Features_Jump_Bullet_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Solo quieres escuchar el resumen? ¿O saltar a los resultados primero? ¡Puedes hacerlo!`)
};

/**
* | output |
* | --- |
* | "Want to only listen to the abstract? Or skip to the results first? You can do that!" |
*
* @param {Features_Jump_Bullet_2Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_jump_bullet_2 = /** @type {((inputs?: Features_Jump_Bullet_2Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Jump_Bullet_2Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_jump_bullet_2(inputs)
	return en_features_jump_bullet_2(inputs)
});